module.exports = __webpack_public_path__ + "a3a9981236c2bc97f4ef5deeee5d1bc7.svg";